import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonV2 from 'src/components/ButtonV2'
import { selectFileResultAvailable } from '../../StockAdjustmentInBatchSeletor'
import { actions } from '../../StockAdjustmentInBatchState'
import * as S from './DownloadCsvButton.styles'

export default () => {
  const enabled = useSelector(selectFileResultAvailable)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(actions.downloadAdjustmentResultFile())
  }, [dispatch])

  if (!enabled) {
    return null
  }

  return (
    <S.Button
      as={ButtonV2}
      onClick={handleClick}
    >
      Download erros de validação (.csv)
    </ S.Button>
  )
}
